export const getFormularioById = async (formulario_id, signal) => {
  const apiBase = process.env.REACT_APP_API_URL;

  const response = await fetch(`${apiBase}/api/formulario/getFormularioById`, {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ formulario_id }),
    signal
  });

  if (!response.ok) throw new Error(`Erro ao buscar formulário: ${response.status}`);
  return await response.json();
};

export const enviarFormulario = async (formulario_id, respostas, signal) => {
  const apiBase = process.env.REACT_APP_API_URL;

  const response = await fetch(`${apiBase}/api/formulario/enviarFormulario`, {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ formulario_id, respostas }),
    signal
  });

  if (!response.ok) throw new Error(`Erro ao enviar formulário: ${response.status}`);
  return await response.json(); // { envio_id }
};

export const getEnvioFormulario = async (envio_id, signal) => {
  const apiBase = process.env.REACT_APP_API_URL;

  const response = await fetch(`${apiBase}/api/formulario/getEnvioById`, {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ envio_id }),
    signal
  });

  if (!response.ok) throw new Error(`Erro ao buscar envio: ${response.status}`);
  return await response.json();
};
